import React from 'react'
import Slider from 'react-slick';
import SectionTC from '../section-tc/section-tc';
import { ArrowIosBack } from '@styled-icons/evaicons-solid'
import { ArrowIosForward } from '@styled-icons/evaicons-solid'
import TitleSection from '../title-section/title-section';
import styled from 'styled-components'
import { device } from '../../config/theme/breakpoints';

const customSlice = `
  > section{
    padding-bottom: 35px;
    width: 90%;
    position: relative;
    margin: auto;

    .slick-slider{
      .slick-dots{
        > li button{
          :before{
            color: red;
            font-size: 12px;
          }
        }
      }

      > ul{
        bottom: -40px;
      }

      > button {
          display: none !important;
      }
    }
  }
`

const GeneralArrow = styled.div`
  width: fit-content;
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  bottom: 0;

  > div {
    background: white;
    padding: 6px;
    border-radius: 50%;
    border: 1px solid #E13028;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;

  > svg{
      color: red;
      width: 16px;
      height: 16px;
      margin: auto;
  }

  :hover{
    background: ${p => p.theme.palette.primary.main};

    > svg{
        color: white;
  }
`

const ContainerGeneralSlider = styled.section<{ size: number }>`
  width: 86% !important;

  @media ${device.mobileL}{
    width: 88% !important;
  }
 
  @media ${device.tablet}{
    width: 92% !important;
  }

  @media ${device.laptop}{
    width: 100% !important;
  }
`

const PrevContainer = styled(GeneralArrow)<{ size: number }>`
  left: -35px;
  display: ${p => p.size > 3 ? 'flex' : 'none'};
  
`

const NextContainer = styled(GeneralArrow)<{ size: number }>`
  right: -35px;
  display: ${p => p.size > 3 ? 'flex' : 'none'};
`

const valuesResponsiveDefault = [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    }
  },
  {
    breakpoint: 920,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0
    }
  }
]

interface IResponsive {
  breakpoint: number,
  settings: {
    slidesToShow: number,
    slidesToScroll: number,
  }
}
interface IOwnProps{
    sliderRef: any;
    className?: string;
    children: any;
    withIconLeft?: boolean;
    withIconRight?: boolean;
    title?: string;
    preTitle?: string;
    size?: number;
    customSlidesToShow?: number;
    customResponsive?: IResponsive[];

}

const CustomSlider: React.FunctionComponent<IOwnProps> = ({
    className,
    children,
    sliderRef,
    title,
    preTitle,
    size = 0,
    customSlidesToShow = 3,
    customResponsive = valuesResponsiveDefault,
    withIconLeft = false,
    withIconRight = false
}) => {
    
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: customSlidesToShow,
      slidesToScroll: 1,
      initialSlide: 0,
      centerPadding: '50px',
      responsive: customResponsive,
    };

    const classSection = `
        ${customSlice || ''}
        ${className || ''}
    `
    
  return (
    <SectionTC className={classSection} withIconRight={withIconRight} withIconLeft={withIconLeft}>
      {(!!title || !!preTitle) && (
        <TitleSection preTitle={preTitle || ''} title={title || ''}/>
      )}
      <ContainerGeneralSlider size={size}>
        <PrevContainer size={size}>
          <div onClick={() => sliderRef.current?.slickPrev()}>
              <ArrowIosBack />
          </div>
        </PrevContainer>
        <Slider {...settings} ref={sliderRef}>
          {children}
        </Slider>
        <NextContainer size={size}>
          <div onClick={() => sliderRef.current?.slickNext()}>
              <ArrowIosForward />
          </div>
        </NextContainer>
      </ContainerGeneralSlider>
    </SectionTC>
  )
}

export default CustomSlider